class VariantPLPSection {

    swap( value, productid, event){
      //document.
      const variantData = JSON.parse(document.getElementById('product-application-'+productid).textContent);
      const colorlebeldata = Array.from(event.parentElement.querySelectorAll('label'));
      colorlebeldata.map((colorlebelfieldset) => {
        colorlebelfieldset.classList.remove('current-active');
      });
      event.classList.add('current-active');
  
      const colorindex = event.parentElement.dataset.optionIndex;
      const listSizeelement = document.querySelector('.list-size[data-product-id="'+productid+'"]');
      const listSizedata = Array.from(listSizeelement.querySelectorAll('label'));
      listSizedata.map((sizelebelfieldset) => {
        sizelebelfieldset.remove();
      });
      const sizeindex = document.querySelector('.list-size[data-product-id="'+productid+'"]').dataset.optionIndex;
      var selectedvariant = '';
      variantData.find((variant) => {
        if( variant[colorindex] == value ){
          if( selectedvariant == '' ) selectedvariant = variant
          var label = document.createElement("label");
          label.innerHTML = this.sizeLabel(variant[sizeindex]);
          if(!variant.available){
            label.classList.add('soldout');
          }else{
            label.setAttribute("onclick","classVariantPLPSection.addtocart("+variant.id+");");
          }
          listSizeelement.appendChild(label);
        }
      });
      if( selectedvariant != '' ){
        this.imageswatch( selectedvariant.id, productid)
      }
    }
  
    sizeLabel(text){
      var selectedtext = text;
      if( text == 'x-small' || text == 'X-small' ){
        selectedtext = "XS";
      }else if( text == 'small' || text == 'Small' ){
        selectedtext = "S";
      }else if( text == 'medium' || text == 'Medium' ){
        selectedtext = "M";
      }else if( text == 'large' || text == 'Large' ){
        selectedtext = "L";
      }else if( text == 'x-large' || text == 'X-large' ){
        selectedtext = "XL";
      }else if( text == 'xx-large' || text == 'X-large' ){
        selectedtext = "XXL";
      }
      return selectedtext;
    }
  
    sliderPrev( productid, event){
      const productSliderElement = document.getElementById('productSliderId-'+productid);
      const currentElement = productSliderElement.querySelector('.slider-item-main .s-item-current');
      if( currentElement.previousElementSibling ){
        currentElement.classList.remove('s-item-current');
        currentElement.previousElementSibling.classList.add('s-item-current');
      }else{
        currentElement.classList.remove('s-item-current');
        productSliderElement.querySelector('.slider-item-main .slider-item:last-child').classList.add('s-item-current');
      }
    }
  
    sliderNext( productid, event){
      const productSliderElement = document.getElementById('productSliderId-'+productid);
      const currentElement = productSliderElement.querySelector('.slider-item-main .s-item-current');
      if( currentElement.nextElementSibling ){
        currentElement.classList.remove('s-item-current');
        currentElement.nextElementSibling.classList.add('s-item-current');
      }else{
        currentElement.classList.remove('s-item-current');
        productSliderElement.querySelector('.slider-item-main .slider-item:first-child').classList.add('s-item-current');
      }
    }
  
    imageswatch(variantid,productid){
      const productSlider = document.getElementById("productSliderId-"+productid);
      const productmainimageListing = document.getElementById("products-slider-listing-"+productid);
      const selectedelements = productmainimageListing.getElementsByClassName('slider-item');
      const slideritemmain = productSlider.querySelector('.slider-item-main');
      this.empty(slideritemmain);
      var flag = true;
      for (var i = 0; i < selectedelements.length; i++) {
        var datavariants = selectedelements.item(i).getAttribute('data-variants');
        const splitvariants = datavariants.split(",");
        if( splitvariants.map(str => Number(str)).includes(variantid) ){
          var dupeelemnt = selectedelements.item(i).cloneNode(true);
          if(flag){
            dupeelemnt.classList.add('s-item-current');
            flag = false;
          }
          slideritemmain.append(dupeelemnt);
        }
      }
    }
  
    empty(element) {
      while(element.firstElementChild) {
         element.firstElementChild.remove();
      }
    }
  
    addtocart( variantid ){
      //var addtocartdata = this.addVariantToCart(variantid);
      var cart = document.querySelector('cart-drawer');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: variantid,
          quantity: 1,
          sections: cart.getSectionsToRender().map((section) => section.id),
          sections_url: window.location.pathname
        })
      }).then((response) => response.json()).then(function (response) {
        if (response.status) {
         
        }else if (!cart) {
          window.location = window.routes.cart_url;
          return;
        }

        cart.renderContents(response);
      }).catch(function (error) {
        console.log(error);
      }).finally(() => {
        //window.nosto.reload();
        Nosto.reloadCart(['cartpage-nosto-4']);
        if (cart && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
      });
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-drawer',
                selector: '#CartDrawer'
            },
            {
                id: 'cart-icon-bubble'
            }
        ];
    }
}

var classVariantPLPSection = new VariantPLPSection();